import {
  createFileRoute,
} from '@tanstack/react-router';

import TabLayout from '#src/components/layouts/TabLayout';
import {
  TabProps,
  TabsGroup,
} from '#src/components/ui/nav/TabsGroup';

export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout',
)({
  component: RouteComponent,
  beforeLoad: () => {
    const adminLinks: TabProps[] = [
      {
        label: 'Settings',
        link: {
          from: Route.fullPath,
          to: '/mydigitalworkers/omni/settings',
        },
        hidden: (context) => {
          if (context?.auth?.user?.profile?.groups) {
            return !((context.auth.user.profile.groups as string[]).includes('client-admin'));
          }
          return false;
        },
      },
    ];
    const defaultLinks: TabProps[] = [
      {
        label: 'Requests',
        link: {
          from: Route.fullPath,
          to: '/mydigitalworkers/omni/requests',
        },
      },
      {
        label: 'Clients',
        link: {
          from: Route.fullPath,
          to: '/mydigitalworkers/omni/clients',
        },
      },
    ];
    return {
      crumb: {
        label: 'Omni',
        href: '/omni',
      },
      header: (
        <>
          <TabsGroup
            tabs={ defaultLinks.concat(adminLinks) }
            defaultTabIndex={ 0 }
          />
        </>
      ),
    };
  },
});

function RouteComponent(): React.ReactNode {
  return (
    <>
      <TabLayout
      // tabs={ userIsClientAdmin ? defaultLinks.concat(adminLinks) : defaultLinks }
      />
    </>
  );
}
